import { FC } from 'react'

import {
  IconMinus,
  IconPlus,
  Button,
  GreyGrey80,
  Sortable,
  Flex
} from '@sequencehq/core-components'
import {
  restrictToFirstScrollableAncestor,
  restrictToVerticalAxis
} from '@dnd-kit/modifiers'
import { useGroups } from '../../hooks'
import { GroupMenuItem } from './GroupMenuItem'

export const GroupMenu: FC<{ nodeId: string }> = ({ nodeId }) => {
  const {
    groups,
    addGroup,
    removeGroup,
    reorderGroups,
    canRemoveGroup,
    canReorderGroups
  } = useGroups({
    nodeId
  })

  return (
    <Flex width="184px" height="100%" flexDir="column" padding="8px" gap="8px">
      <Flex flexDir="column" flex="1" overflowY="auto" gap="1px">
        <Sortable.Group
          modifiers={[
            restrictToVerticalAxis,
            restrictToFirstScrollableAncestor
          ]}
          items={groups}
          onDragEnd={reorderGroups}
        >
          {groups.map((group, index) => (
            <Sortable.Item key={group.id} id={group.id}>
              {handleProps => (
                <GroupMenuItem
                  id={group.id}
                  label={group.label}
                  index={index}
                  nodeId={nodeId}
                  handleProps={canReorderGroups ? handleProps : undefined}
                />
              )}
            </Sortable.Item>
          ))}
        </Sortable.Group>
      </Flex>

      <Flex>
        <Button
          data-testid="automations.editor.configForm.switch.groupMenu.addBranch"
          variant="ghost"
          icon={<IconPlus color={GreyGrey80} />}
          aria-label="Add branch"
          onClick={addGroup}
        />

        <Button
          data-testid="automations.editor.configForm.switch.groupMenu.removeBranch"
          variant="ghost"
          icon={
            <IconMinus
              color={GreyGrey80}
              style={{ opacity: canRemoveGroup ? 1 : 0.5 }}
            />
          }
          aria-label="Remove case"
          disabled={!canRemoveGroup}
          onClick={removeGroup}
        />
      </Flex>
    </Flex>
  )
}
